import { useEffect } from 'react'

import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'
import { useAuthActions } from '@/shared/lib/auth/actions'

export const Route = createFileRoute('/_event/sign-out')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: SignOutPage
})

function SignOutPage() {
  const tenant = useTenantOptional()
  const navigate = useNavigate()
  const { signOut } = useAuthActions()

  useEffect(() => {
    if (!tenant?.hasTenant || !tenant.digitalProductId) {
      navigate({ to: '/sem-evento', replace: true })
      return
    }

    void signOut({
      digitalProductId: tenant.digitalProductId,
      callbackUrl: '/',
      redirect: true
    })
  }, [navigate, signOut, tenant?.digitalProductId, tenant?.hasTenant])

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" role="status" />
    </div>
  )
}
